import { Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { A, Z, ZERO, NINE, SPACE } from '@angular/cdk/keycodes';

@Component({
  selector: 'app-tgss-select-filter',
  templateUrl: './tgss-select-filter.component.html',
  styleUrls: ['./tgss-select-filter.component.css'],
  providers: [
    {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => TgssSelectFilterComponent),
        multi: true,
    },
    {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => TgssSelectFilterComponent),
        multi: true,
    }]
})
export class TgssSelectFilterComponent implements OnInit, OnDestroy {

  @ViewChild('input') public input;
  @Input() array: any = [];
  @Input() placeholder: any;
  @Input() color: any;
  @Input() displayMember: any;
  @Input() showSpinner: boolean = false;
  @Input() noResultsMessage: any;
  @Input() hasGroup: any;
  @Input() groupArrayName: any;
  @Output() filteredReturn = new EventEmitter();

  helperarray: any = []
  noResults: boolean = false;
  localSpinner: boolean = false;
  filteredItems: any = [];
  searchForm: FormGroup;
  constructor(public fb: FormBuilder) {
      this.showSpinner = true;
      this.noResultsMessage = 'No results';
      this.noResults = false;
      this.localSpinner = false;
      this.filteredReturn = new EventEmitter<any>();
      this.filteredItems = [];
      this.searchForm = fb.group({
          value: ''
      });
  }

  ngOnInit() {
      this.helperarray = this.array;
      this.searchForm.valueChanges.subscribe(value => {
          if (this.showSpinner) {
              this.localSpinner = true;
          }
          if (value['value']) {
              // IF THE DISPLAY MEMBER INPUT IS SET WE CHECK THE SPECIFIC PROPERTY
              if (this.displayMember == null) {
                  this.filteredItems = this.array.filter(name => name.toLowerCase().includes(value['value'].toLowerCase()));
                  // OTHERWISE, WE CHECK THE ENTIRE STRING
              }
              else if (this.hasGroup && this.groupArrayName && this.displayMember) {
                  this.filteredItems = this.array.map(a => {
                      const objCopy = Object.assign({}, a);
                      objCopy[this.groupArrayName] = objCopy[this.groupArrayName].filter(g => g[this.displayMember].toLowerCase().includes(value['value'].toLowerCase()));
                      return objCopy;
                  }).filter(x => x[this.groupArrayName].length > 0);
              }
              else {
                  this.filteredItems = this.array.filter(name => name[this.displayMember].toLowerCase().includes(value['value'].toLowerCase()));
              }
              // NO RESULTS VALIDATION
              this.noResults = this.filteredItems == null || this.filteredItems.length === 0;
          }
          else {
              this.filteredItems = this.array.slice();
              this.noResults = false;
          }
          this.filteredReturn.emit(this.filteredItems);
          setTimeout(() => {
              if (this.showSpinner) {
                  this.localSpinner = false;
              }
          }, 2000);
      });
      setTimeout(() => {
          this.input.nativeElement.focus();
      }, 500);
      if (!this.placeholder) {
          this.placeholder = 'Search...';
      }
  }
  handleKeydown(event) {
      // PREVENT PROPAGATION FOR ALL ALPHANUMERIC CHARACTERS IN ORDER TO AVOID SELECTION ISSUES
      if ((event.key && event.key.length === 1) ||
          (event.keyCode >= A && event.keyCode <= Z) ||
          (event.keyCode >= ZERO && event.keyCode <= NINE) ||
          (event.keyCode === SPACE)) {
          event.stopPropagation();
      }

      if(event.keyCode === 8){
          let helperarray = this.helperarray;
          this.searchForm.valueChanges.subscribe(value => {
              if (this.showSpinner) {
                  this.localSpinner = true;
              }
              if (value['value']) {
                  // IF THE DISPLAY MEMBER INPUT IS SET WE CHECK THE SPECIFIC PROPERTY
                  if (this.displayMember == null) {
                      this.filteredItems = helperarray.filter(name => name.toLowerCase().includes(value['value'].toLowerCase()));
                      // OTHERWISE, WE CHECK THE ENTIRE STRING
                  }
                  else if (this.hasGroup && this.groupArrayName && this.displayMember) {
                      this.filteredItems = helperarray.map(a => {
                          const objCopy = Object.assign({}, a);
                          objCopy[this.groupArrayName] = objCopy[this.groupArrayName].filter(g => g[this.displayMember].toLowerCase().includes(value['value'].toLowerCase()));
                          return objCopy;
                      }).filter(x => x[this.groupArrayName].length > 0);
                  }
                  else {
                      this.filteredItems = helperarray.filter(name => name[this.displayMember].toLowerCase().includes(value['value'].toLowerCase()));
                  }
                  // NO RESULTS VALIDATION
                  this.noResults = this.filteredItems == null || this.filteredItems.length === 0;
              }
              else {
                  this.filteredItems = helperarray.slice();
                  this.noResults = false;
              }
              this.filteredReturn.emit(this.filteredItems);
              setTimeout(() => {
                  if (this.showSpinner) {
                      this.localSpinner = false;
                  }
              }, 2000);
          });
      }
  }
  ngOnDestroy() {
      this.filteredReturn.emit(this.helperarray);
  }

}
